import { SongService } from "@/services/SongService";
import { PlaylistService } from "@/services/PlaylistService";
import { mapState } from "vuex";

var SongsSortingMixin = {
	data() {
		return {
			sorting: {
				element: null,
				dropElement: null,
				dropId: null,
				longClick: null
			}
		}
	},
	computed: {
		...mapState([ "queueSongsOrders", "songsSorting", "songsFilter", "playlistsSongsOrders" ])
	},
	methods: {
		handleMouseDown(e) {
			if (!this.canSort) return;
			const currentTarget = e.currentTarget
			this.sorting.longClick = setTimeout(() => {
				this.$store.commit("setSongsSorting", true);
				this.sorting.element = currentTarget;
				this.sorting.dropId = currentTarget.getAttribute("data-song");
			}, 160)
		},
		handleMouseUp() {
			if (!this.canSort) return;
			clearTimeout(this.sorting.longClick)
			this.$store.commit("setSongsSorting", false);
			this.sorting = {
				element: null,
				dropElement: null,
				dropId: null
			};
		},
		dragOver(e) {
			if (!this.canSort) return;
			e.preventDefault();
			this.sorting.dropElement = e.currentTarget;
			this.sorting.dropId = this.sorting.dropElement.getAttribute("data-song");
		},
		dragStart(e) {
			this.$store.commit("setSongsSorting", true);
			this.sorting.element = e.currentTarget;
			this.sorting.dropId = e.currentTarget.getAttribute("data-song");
		},
		drop() {
			if (!this.canSort) return;
			clearTimeout(this.sorting.longClick)
			if (!this.songsSorting) return;
			this.$store.commit("setSongsSorting", false);

			var source = [];
			if (this.songsFilter.onlyQueue) {
				source = this.queueSongsOrders;
			} else if (this.songsFilter.playlist !== null) {
				source = this.playlistsSongsOrders[this.songsFilter.playlist];
			}

			var prevOrder = 0;
			if (this.sorting.dropElement.previousSibling !== null) {
				prevOrder = source[this.sorting.dropElement.previousSibling.getAttribute("data-song")];
			}

			var nextOrder = source[this.sorting.dropElement.getAttribute("data-song")];
			var order = parseInt(prevOrder + ((nextOrder - prevOrder) / 2));

			if (this.songsFilter.onlyQueue) {
				SongService.sortSongInQueue(this.$store.state.songs[this.sorting.element.getAttribute("data-song")], order);
			} else if (this.songsFilter.playlist !== null) {
				PlaylistService.sortSongInPlaylist(
					this.$store.state.playlists[this.songsFilter.playlist],
					this.$store.state.songs[this.sorting.element.getAttribute("data-song")],
					order
				);
			}

			this.sorting.dropElement.parentNode.insertBefore(this.sorting.element, this.sorting.dropElement);
			this.sorting = {
				element: null,
				dropElement: null,
				dropId: null
			};

			document.dispatchEvent(new Event("RefreshSongs"));
		},
		touchStart(id) {
			if (!this.canSort) return;
			this.sorting.longClick = setTimeout(() => {
				const el = document.querySelectorAll(`[data-song='${id}']`)[0]
				this.$store.commit("setSongsSorting", true);
				this.sorting.element = el;
				this.sorting.dropId = id;

			}, 400)
		},
		touchMove(e) {
			if (!this.canSort) return;
			if (e.changedTouches[0].clientY > 10 && e.changedTouches[0].clientY > 10) {
				clearTimeout(this.sorting.longClick)
			}

			if (!this.songsSorting) return;
			e.preventDefault();
			var songElements = document.getElementsByClassName("song");

			for (var i = 0; i < songElements.length; i++) {
				var el = songElements[i];
				var rect = el.getBoundingClientRect();
				if (e.changedTouches[0].clientY > rect.top && e.changedTouches[0].clientY < rect.bottom) {
					this.sorting.dropElement = el;
					this.sorting.dropId = this.sorting.dropElement.getAttribute("data-song");
					break;
				}
			}
		},
	}
};


export { SongsSortingMixin };
